
import {Component, Prop, Vue} from "vue-property-decorator";
import LoyaltyStockUpdateForm from "@/form/loyalty/loyaltyStock/LoyaltyStockUpdateForm";
import FormGroup from "@/UI/components/common/form/FormGroup.vue";
@Component({
  components: {FormGroup},
})
export default class LoyaltyStockUpdateFormComponent extends Vue {
  @Prop() form!: LoyaltyStockUpdateForm;

}
